var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hot-class"},[_c('studyTable',{attrs:{"tableData":_vm.tableDataTemp,"pages":_vm.pages,"columns":_vm.columns,"num":_vm.num}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }